var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-space-between flex-column text-center call-container"},[_c('vidyo-chat-container',{on:{"leftMeeting":_vm.leaveMeeting,"meetingJoined":_vm.onMeetingJoined}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }